<template>
  <b-row>
    <b-col>

      <b-card 
        :style="onlyView ? '' : isModalView" 
        no-body 
        :class="{ 'open': visibleBody }"
      >

        <b-card-header 
          style="color: black; font:45px; padding: 0 1px; cursor: pointer;"
          :class="{ 'collapsed': !visibleBody }" 
          :aria-expanded="visibleBody ? 'true' : 'false'" 
          role="tab"
          data-toggle="collapse" @click="onVisibleBody(!visibleBody)">
          <span class="lead collapse-title">
            <strong>EVALUACIÓN PSICOLÓGICA</strong>
          </span>
          <i :class="visibleBody ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"></i>
        </b-card-header>
        
        <b-collapse v-model="visibleBody" role="tabpanel">
          <b-card-body style="margin:0;">
            
            <fieldset :disabled="onlyView">
              <b-row>
                <b-col>
                  <div class="d-flex">
                    <label>
                      <b>¿Embarazo?:</b>
                      {{ psicologia.embarazo ? "Si" : "No" }}
                    </label>

                    <b-form-checkbox 
                      switch 
                      v-model="psicologia.embarazo" 
                      class="mx-2" 
                    />
                  </div>
                </b-col>
              </b-row>

              <b-row class="mt-1">
                <b-col>
                  <label> <b>Hábitos:</b> </label>

                  <b-form-checkbox-group 
                    id="checkbox-habitos" 
                    :options="habitosOpts" 
                    v-model="psicologia.habitosSelected" 
                    @input="onSelectedHabitos"
                    class="checkbox-two-col" 
                  />

                </b-col>
              </b-row>


              <b-row class="my-2">
                <b-col>
                  <div v-for="(habito) in psicologia.habitos" :key="habito.value" class="row mb-2">
                    <div class="col-sm-4">
                      <label>{{ habito.text }}</label>
                    </div>
                    <div class="col-sm-8">
                      <b-form-input 
                        v-model="habito.inputText" 
                        placeholder="Describa el habito..." 
                        type="text"
                      />
                    </div>
                  </div>

                </b-col>
              </b-row>


              <b-row class="mt-1">
                <b-col>
                  <b-form-group>
                    <label> Genograma </label>
                    <b-form-textarea 
                      v-model="psicologia.genograma" 
                    />
                  </b-form-group>


                  <b-form-group>
                    <label> Funciones basicas/Procesos cognitivos superiores</label>
                    <b-form-textarea 
                      v-model="psicologia.funcionesBasicas" 
                    />
                  </b-form-group>

                  <b-form-group class="mt-1">
                    <label>Evaluacion Clinica</label>
                    <b-form-textarea 
                      v-model="psicologia.evaluacionClinica" 
                    />
                  </b-form-group>

                </b-col>
              </b-row>

              <b-row class="mt-1">
                <b-col>
                  <label>
                    <b>Instrumentos Psicologicos</b>
                  </label>

                  <div class="d-flex my-1">
                    <label>
                      <b>¿Aplica?:</b>
                      {{ psicologia.aplicaInstrumentos ? "Si" : "No" }}
                    </label>

                    <b-form-checkbox 
                      switch 
                      v-model="psicologia.aplicaInstrumentos" 
                      class="mx-2"
                    />
                  </div>
                </b-col>

              </b-row>


              <b-row v-if="psicologia.aplicaInstrumentos">
                <b-col>
                  <label><b>Seleccione el instrumento:</b></label>

                  <b-form-checkbox-group 
                    id="checkbox-instrumentos" 
                    :options="instrumentosOpts"
                    v-model="psicologia.instrumentosSelected" 
                    @input="onSelectedInstrumentos" 
                    class="checkbox-two-col" 
                  />

                </b-col>
              </b-row>

              <b-row class="my-2">
                <b-col>
                  <div 
                    v-for="(instrumento) in psicologia.instrumentos" 
                    :key="instrumento.value" 
                    class="row mb-2"
                  >
                    <div class="col-sm-4">
                      <label>{{ instrumento.text }}</label>
                    </div>
                    <div class="col-sm-8">
                      <b-form-input 
                        v-model="instrumento.inputText" 
                        placeholder="Ingrese el resultado" 
                        type="text"
                      />
                    </div>
                  </div>

                </b-col>
              </b-row>

              <hr class="my-2">
              <b-row>
                <b-col>
                  <b-form-group>
                    <h6> Test de screening  </h6>
                    <b-form-textarea 
                      v-model="psicologia.screening" 
                    />
                  </b-form-group>
                </b-col>
              </b-row>

              <b-form-group class="mt-1">
                <b-button 
                  v-if="!onlyView" 
                  @click="copyAS400()" 
                  variant="info"
                >
                  AS400 <i class="fas fa-copy" />
                </b-button>
              </b-form-group>
            </fieldset>
            
          </b-card-body>
        </b-collapse>
      </b-card>
    </b-col>
  </b-row>

</template>

<script>

import { BootstrapVue } from 'bootstrap-vue';
import { mapState } from "vuex";
import { copyText } from "@/shared/helpers";

export default {

  created() {
    if(this.onlyView) this.visibleBody = true
  },

  props: {
    onlyView: {
      type: Boolean,
      default: false
    },

    dataSaved: {
      type: Object,
      default: null
    }
  },

  data() {
    return {
      visibleBody: false,

      psicologia: {
        habitosSelected      : [],
        instrumentosSelected : [],
        embarazo             : false,
        habitos              : [],
        funcionesBasicas     : '',
        evaluacionClinica    : '',
        genograma            : '',
        aplicaInstrumentos   : false,
        instrumentos         : [],
        screening            : ''
      },

      habitosOpts: [
        { text: 'Alcohol',      value: 'alchohol',     inputText: '' },
        { text: 'Drogas',       value: 'drogas',       inputText: '' },
        { text: 'Tabaco',       value: 'tabaco',       inputText: '' },
        { text: 'Alimentacion', value: 'alimentacion', inputText: '' },
        { text: 'Sueño',        value: 'sueno',        inputText: '' },
        { text: 'Otros',        value: 'otros',        inputText: '' },
      ],

      instrumentosOpts: [
        {
          text: 'Cuestionarios',
          value: 'cuestionarios',
          inputText: ''
        },
        {
          text: 'Escalas de Auto-Informe',
          value: 'autoinforme',
          inputText: ''
        },

        {
          text: 'Pruebas proyectivas',
          value: 'proyectivas',
          inputText: ''
        },

        {
          text: 'Pruebas de inteligencia',
          value: 'inteligencia',
          inputText: ''
        },

        {
          text: 'Habilidades cognitivas',
          value: 'habilidades',
          inputText: ''
        },

        {
          text: 'Pruebas neuropsicologicas',
          value: 'neuropsicologicas',
          inputText: ''
        },

        {
          text: 'Observacion y Entrevistas',
          value: 'entrevistas',
          inputText: ''
        },

        {
          text: 'Pruebas de rendimiento academico',
          value: 'rendimiento',
          inputText: ''
        }
      ],

      
    }
  },


  methods: {
    onVisibleBody(value) {
      this.visibleBody = value
    },

    onSelectedHabitos(selectedIds) {
      const newHabitos = [];
      const actHabitos = this.psicologia.habitos;

      selectedIds.forEach(id => {
        const existing = actHabitos.find(element => element.value === id);

        if (existing) {
          newHabitos.push({
            value: existing.value,
            text: existing.text,
            inputText: existing.inputText
          });
        } else {
          
          const newItem = this.habitosOpts.find(item => item.value === id);
          if (newItem) {
            newHabitos.push({ ...newItem, inputText: '' });
          }
        }
      });
      this.psicologia.habitos = newHabitos
    },


    onSelectedInstrumentos(selectedIds) {

      const newIntrumentos = [];
      const actIntrumentos = this.psicologia.instrumentos;

      selectedIds.forEach(id => {
        const existing = actIntrumentos.find(element => element.value === id);

        if (existing) {
          newIntrumentos.push({
            value : existing.value,
            text  : existing.text,
            inputText: existing.inputText
          });
        } else {
          
          const newItem = this.instrumentosOpts.find(item => item.value === id);
          if (newItem) {
            newIntrumentos.push({ ...newItem, inputText: '' });
          }
        }
      });
      this.psicologia.instrumentos = newIntrumentos


    },


    copyAS400() {
      let text = '';

      if (this.psicologia) {

        let habitos      = null;
        let instrumentos = null;

        if(this.psicologia.habitos){
          habitos = this.psicologia.habitos.map( 
            h => (`${h.text}: ${h.inputText}`) 
          ).join(", ");
        }

        if(this.psicologia.instrumentos){
          instrumentos = this.psicologia.instrumentos.map( 
            i => (`${i.text}: ${i.inputText}`) 
          ).join(", ");
        }

        text = `Evaluación Psicológica: 
${this.psicologia.embarazo ? 'Paciente embarazada' : ''}
${habitos ? `Habitos: ${habitos}` : ''}
Genograma: ${this.psicologia.genograma}
Evaluación de funciones básicas: ${this.psicologia.funcionesBasicas}
Evaluación clínica: ${this.psicologia.evaluacionClinica}
${instrumentos ? `Instrumentos: ${instrumentos}` : ''} `
      }

      copyText(text);
      
      this.$bvToast.toast('El texto ha sido copiado', {
        title: `Copiado`,
        variant: 'success',
      })
    },

  },
  computed: {
    ...mapState({
      stDataDoctor: state => state.atencionCita.dataCita?.doctor,
      stSemiologiaView: state => state.atencionMedica.dataAtencion.semiologiaView
    }),

    esPsicologia() {
      return this.stDataDoctor?.especialidad?.codEsp === '0000000522';
    },

    
    isModalView() {
      return {
        margin: '0',
        border: '1px solid #2980b9',
        padding: '0 10px'

      }
    }


  },

  watch: {

    stSemiologiaView:{
      immediate: true,
      handler(newValue){

        if(!this.onlyView) return;

        if (newValue) {
          this.psicologia = newValue
        }
        
      }
    },

    dataSaved: {
      deep: true,
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.psicologia = newValue
        }
      }
    },

    psicologia: {
      deep: true,
      inmediate: true,
      handler(nv) {

        if(this.onlyView) return;
        
        const data = {
          tipo: 'psicologia',
          data: nv
        }


        this.$store.commit("setSemActual", data);
      }
    },

    'psicologia.aplicaInstrumentos': {
      deep: true,
      inmediate: true,
      handler(nv) {
        if (!nv) {
          this.psicologia.instrumentos = []
          this.psicologia.instrumentosSelected = []
        }
      }
    }

  },

  components: {
    ...BootstrapVue.components,
  },
}
</script>

<style>
.checkbox-two-col .custom-checkbox {
  width: 47%;
}
</style>